  import { create } from "zustand";
  import CameraManager from "../manager/CameraManager";
  import { audios, subtitles } from "../../assets/assets";

  const flowSteps = [
    {
      id: 0,
      label: "Start",
      ui: "start",
      audio: audios.introduction,
      subtitle: subtitles.introduction,
      camera: "camera_1",
    },
    {
      id: 1,
      label: "HubStart",
      camera: "camera_1",
      ui: "interact",
      interact: {
        label: "Le mail",
        order: 0,
        totalSteps: 4,
        indication: "Cliquez sur le bureau",
      },
    },
    {
      id: 2,
      label: "HubScreen",
      camera: "camera_2",
      audio: audios.mail_superflamme,
      subtitle: subtitles.mail_superflamme,
      ui: "interact",
      interact: {
        label: "Le mail",
        order: 0,
        totalSteps: 4,
        indication: "Acceptez la mission",
      },
    },
    {
      id: 3,
      audio: audios.mail_accepte,
      subtitle: subtitles.mail_accepte,
      label: "HubScreenToLargeAngle",
      camera: "camera_3",
      ui: "interact",
      interact: {
        label: "La porte",
        order: 0,
        totalSteps: 4,
        indication: "Cliquez sur la porte",
      },
    },
    {
      id: 4,
      label: "HubDoor",
      camera: "camera_4",
    },
    {
      id: 5,
      label: "Transition",
      audio: audios.transition_nuage,
      subtitle: subtitles.transition_nuage,
      ui: "transition",
    },
    {
      id: 6,
      label: "Nuages",
      camera: "camera_1",
    },
    {
      id: 7,
      label: "Telescope",
      audio: audios.entree_chambre,
      subtitle: subtitles.entree_chambre,
      camera: "camera_2",
      ui: "interact",
      interact: {
        label: "Le Télescope",
        order: 1,
        totalSteps: 4,
        indication: "Rapprochez-vous du télescope",
      },
    },
    {
      id: 8,
      label: "Trouver la lune",
      audio: audios.focus_telescope,
      subtitle: subtitles.focus_telescope,
      ui: "moon",
      interact: {
        label: "La Lune",
        order: 2,
        totalSteps: 4,
        indication: "Trouvez la lune",
      },
    },
    {
      id: 9,
      label: "Lune trouvée",
      audio: audios.fin_telescope,
      subtitle: subtitles.fin_telescope,
      camera: "camera_3",
      ui: "moon",
      interact: {
        label: "La Lune",
        order: 2,
        totalSteps: 4,
        indication: "Déplacez le curseur pour faire le focus",
      },
    },
    {
      id: 10,
      label: "Carburant",
      camera: "camera_5",
      ui: "interact",
      interact: {
        label: "Le carburant",
        order: 2,
        totalSteps: 4,
        indication: "Tournez les vannes correctement puis validez avec le levier",
      },
    },
    {
      id: 11,
      label: "Buzzer",
      camera: "camera_6",
      onFuseeLaunch: true,
      ui: "interact",
      interact: {
        label: "Le décollage",
        order: 3,
        totalSteps: 4,
        indication: "Faites décoller la fusée",
      },
    },
    {
      id: 12,
      label: "End",
      ui: "end",
      audio: audios.fin_experience,
      subtitle: subtitles.fin_experience,
    },
  ];

  const useFlowStore = create((set, get) => ({
    currentStep: 0,
    autoFindMoon: true,
    playingAudio: false,
    audioSrc: null,
    subtitleSrc: null,
    showMoonUI: false,
    showEndUI: false,
    showStartUI: false,
    showTransitionUI: false,
    flowSteps,
    onAudioComplete: null,
    fuseeShouldLaunch: false,

    videoOverlayVisible: false,
    setVideoOverlayVisible: (val) => set({ videoOverlayVisible: val }),

    interactUIRef: null,
    setInteractUIRef: (ref) => set({ interactUIRef: ref }),

    showDesktopInteractUI: false,
    setShowDesktopInteractUI: (value) => set({ showDesktopInteractUI: value }),
    desktopIsClickable: false,
    setDesktopIsClickable: (val) => set({ desktopIsClickable: val }),
    showInterface: false,
    setShowInterface: (val) => set({ showInterface: val }),

    showInteractUI: false,
    setShowInteractUI: (val) => {
      console.log("[store] setShowInteractUI", val, "step:", get().currentStep);
      set({ showInteractUI: val });
    },

    backgroundMusicMuted: false,
    toggleBackgroundMusicMuted: () =>
      set((state) => ({ backgroundMusicMuted: !state.backgroundMusicMuted })),

    visibleScenes: {
      hub: true,
      secondaryScene: false,
    },

    setSceneVisible: (sceneName, isVisible) =>
      set((state) => ({
        visibleScenes: {
          ...state.visibleScenes,
          [sceneName]: isVisible,
        },
      })),

    cameraManagerReady: false,
    setCameraManagerReady: (val) => set({ cameraManagerReady: val }),

    nextStep(onFinished, options = {}) {
      const next = get().currentStep + 1;
      const step = flowSteps[next];
    
      if (!step) {
        console.error("❌ Step introuvable !");
        return;
      }

      console.log("🎬 Step changed :", step);
    
      // 1. Switch camera d'abord, toujours AVANT tout reset
      // if (step.camera && !options.skipSwitch) {
      //   CameraManager.switchCamera(step.camera);
      // }
    
      // 2. (Optionnel) Reset SEULEMENT si tu reviens à un état neutre (genre retour début)
      // if (!options.skipReset) {
      //   CameraManager.reset?.();
      // }
    
      // 3. On gère l’état React
      set({
        currentStep: next,
        showMoonUI: step.ui === "moon",
        showEndUI: step.ui === "end",
        showStartUI: step.ui === "start",
        showTransitionUI: step.ui === "transition",
      });
    
      // 4. Stop audio si besoin
      if (step.id != 1 && step.id != 10 && step.id != 11) {
        get().stopAudio();
      }
    
      // 5. Callback, etc.
      onFinished?.();
    },
    
    // Ajout d'un callback onFinished optionnel sur nextStep
    nextStepDebug(onFinished) {
      const next = get().currentStep + 1;
      const step = flowSteps[next];
      if (!step) return;

      console.log("🎬 Step changed :", step);

      if (step.id != 1 || step.id != 10 || step.id != 11) {
        get().stopAudio();
      }
      // CameraManager.reset?.();

      const isSecondary = step.id >= 5;

      set({
        currentStep: next,
        visibleScenes: {
          hub: !isSecondary,
          secondaryScene: isSecondary,
        },
        desktopIsClickable: step.id === 1,
        showMoonUI: step.ui === "moon",
        showEndUI: step.ui === "end",
        showStartUI: step.ui === "start",
        showTransitionUI: step.ui === "transition",
      });

      // if (step.camera) {
        // console.log("🎥 Switch Camera (Next):", step.camera);
        // CameraManager.switchCamera(step.camera);
      // }

      // Exécute le callback si fourni après traitement
      onFinished?.();
    },

    previousStep(onFinished) {
      const prev = get().currentStep - 1;
      const step = flowSteps[prev];
      if (!step) return;

      console.log("🎬 Step changed :", step);
      get().stopAudio();
      CameraManager.reset?.();

      const isSecondary = step.id >= 5;

      set({
        currentStep: prev,
        visibleScenes: {
          hub: !isSecondary,
          secondaryScene: isSecondary,
        },
        desktopIsClickable: step.id === 1,
        showMoonUI: step.ui === "moon",
        showEndUI: step.ui === "end",
        showStartUI: step.ui === "start",
        showTransitionUI: step.ui === "transition",
      });

      // if (step.camera) {
        console.log("🎥 Switch Camera (Next):", step.camera);
        CameraManager.switchCamera(step.camera);
      // }

      // Exécute le callback si fourni après traitement
      onFinished?.();
    },

    resetFlow() {
      console.log("🔄 [Flow] Reset Flow to Step 0");
      get().setStep(0);
    },

    switchCurrentCamera() {
      const step = flowSteps[get().currentStep];
      if (!step) return;
      CameraManager.switchCamera(step.camera);
    },

    setStep(stepIndex) {
      const step = flowSteps[stepIndex];
      if (!step) return;

      console.log(`🚀 [Flow] Set Specific Step: [${stepIndex}] ${step.label}`);

      if (step.id != 1 || step.id != 10 || step.id != 11) {
        get().stopAudio();
      }

      CameraManager.reset?.();

      const isSecondary = step.id >= 5;

      // if (step.id == 3) {
      //   // get().setShowInterface(true);
      // }

      set({
        currentStep: stepIndex,
        visibleScenes: {
          hub: !isSecondary,
          secondaryScene: isSecondary,
        },
        desktopIsClickable: step.id === 1,
        showMoonUI: step.ui === "moon",
        showEndUI: step.ui === "end",
        showStartUI: step.ui === "start",
        showTransitionUI: step.ui === "transition",
      });

      if (step.camera) {
        console.log("🎥 Switch Camera (Next):", step.camera);
        setTimeout(() => {
          CameraManager.switchCamera(step.camera);
        }, 1000);
      }
    },

    playCamera() {
      const step = flowSteps[get().currentStep];
      if (!step) return;

      if (step.camera) {
        console.log("🎥 Play Camera (Current):", step.camera);
        CameraManager.switchAndPlay(step.camera);
      } else {
        console.warn("⚠️ Pas de caméra pour ce step :", step.label);
      }
    },

    playCurrentAudio(onFinished) {
      const step = flowSteps[get().currentStep];
      if (!step?.audio) return;
      // -- PATCH ANTI-DOUBLE --
      if (get().audioSrc === step.audio && get().playingAudio) {
        // L'audio de ce step joue déjà, on ne le relance pas
        console.log("⏩ Audio déjà en lecture, on ne relance pas.");
        return;
      }
      console.log("🎶 [Flow] Play Current Audio Only:", step.audio);
      get().stopAudio();
      get().playAudioFile(step.audio, step.subtitle, onFinished);
    },
    

    playAudioFile(audio, subtitle, onFinished) {
      // console.log(`🔊 [Flow] -> Playing Audio: ${audio}`);
      const step = flowSteps[get().currentStep];

      set({
        playingAudio: true,
        audioSrc: audio,
        subtitleSrc: subtitle,
        onAudioComplete: () => {

          set({
            playingAudio: false,
            audioSrc: null,
            subtitleSrc: null,
          });

          onFinished?.();
        },
      });
    },

    stopAudio() {
      set({ playingAudio: false, audioSrc: null, subtitleSrc: null });
    },

    triggerFuseeLaunch() {
      console.log("🚀 Déclenchement du décollage de la fusée");
      set({ fuseeShouldLaunch: true });
    },
    finishAudio() {
      const { onAudioComplete } = get();
      if (typeof onAudioComplete === "function") {
        onAudioComplete();
      }
    },
  }));

  export default useFlowStore;
